// @flow

import { all, put, takeEvery, call } from "redux-saga/effects";
import type { Action } from "redux-action";
import http from "@http";

import actionCreators from "@modules/shared/actionCreator";
import { GetAlerts } from "@modules/shared/constants/actions";

type ListResponse<T> = $Exact<{
  content: T,
  paginations: any,
}>;

type ListRequest = $Exact<{
  clientId: string,
}>;

export function* onGetAlerts({
  payload,
}: Action<ListRequest>): Generator<*, void, { data: ListResponse<Array<Object>> }> {
  try {
    if (!payload || !payload.clientId) {
      throw Error("Invalid payload provided");
    }

    const response = yield call(
      http.get,
      // TODO check v2
      `/api/v2/service-admin/client/${payload.clientId}/service-config/absence-management/alert/configuration`,
    );

    yield put(actionCreators.GetAlertsSuccess(response.data.content));
  } catch (e) {
    yield put(actionCreators.GetAlertsError(e.response));
  }
}

export function* AlertsSagas(): Generator<*, void, void> {
  yield all([takeEvery(GetAlerts, onGetAlerts)]);
}

export default AlertsSagas;
